import _ from 'lodash';
import moment from 'moment';
import {IWorkshop} from '../interface';

const analyseData = {
  getPosition: (min: number, max: number, value: number) => {
    return `${(value - min) / (max - min) * 100}%`;
  },
  hourFormat: (hour: string) => {
    return moment(hour, 'HH:mm').format('kk : mm');
  },
  arryToString: (ary: string[]) => {
    return _.chain(ary).join(' , ').value();
  },
  ratingGroup: (workshops: IWorkshop[]) => {
    return _.chain(workshops).map(d => d['rating']).countBy().value()
  }
};

export default analyseData;
